import { BRAND } from "Settings";
import { getCustomTheme } from "./getCustomTheme";

export default getCustomTheme(BRAND);
